import axios from "axios";
import { BASESERVICEAPI } from "@src/config/env";
const BASEAPI =BASESERVICEAPI

const service = axios.create({
  baseURL: BASEAPI,
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 50000, // request timeout
});

const CancelToken = axios.CancelToken;

// request interceptor
service.interceptors.request.use(
  (config) => {
    config.cancelToken = new CancelToken((cancel) => {});
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
